"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconLeanNimble = function SvgIconLeanNimble(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "lean nimble icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Lean Nimble Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M41.56 22.94l-16.5-16.5a1.5 1.5 0 00-2.12 0l-16.5 16.5a1.5 1.5 0 000 2.12l16.5 16.5a1.5 1.5 0 002.12 0l16.5-16.5a1.5 1.5 0 000-2.12zm-3.45 1.325L24.263 38.114a.375.375 0 01-.53 0L9.886 24.266a.375.375 0 010-.531L23.735 9.886a.375.375 0 01.53 0l13.849 13.849a.375.375 0 010 .53h-.003zM25.19 15.75a1.5 1.5 0 012.12 0l3.221 3.219a.75.75 0 01-.53 1.28h-1.126a.375.375 0 00-.375.376v3.814c.002.399-.157.78-.44 1.061l-3.95 3.951a.374.374 0 00-.11.266v2.533a1.5 1.5 0 01-1.5 1.5H21a1.5 1.5 0 01-1.5-1.5v-4.19c-.002-.397.157-.78.44-1.06l3.95-3.951c.07-.07.11-.166.11-.265v-2.16a.375.375 0 00-.375-.374H22.5a.75.75 0 01-.531-1.281l3.22-3.22z"
  }));
};

var _default = SvgIconLeanNimble;
exports.default = _default;